(() => {
  const cleanups = new Map();

  function initializeArticles(root = document) {
    const articles = [...root.querySelectorAll('.single_article')];
    if (root.matches?.('.single_article')) articles.unshift(root);

    articles.forEach(article => {
      if (cleanups.has(article)) return;
      const contents = article.querySelector('.table_content');
      const navigation = article.querySelector('.contect_list');
      const body = article.querySelector('.article__content');
      if (!contents || !navigation || !body) return;

      // Editor spacer paragraphs should not add arbitrary gaps to the reading rhythm.
      body.querySelectorAll('p').forEach(paragraph => {
        if (!paragraph.textContent.trim() && !paragraph.querySelector('img, picture, video, audio, iframe, svg, canvas, input, button')) {
          paragraph.hidden = true;
        }
      });
      const links = document.createDocumentFragment();
      const headings = [...body.querySelectorAll('h2')].filter(heading => heading.textContent.trim());
      headings.forEach((heading, index) => {
        const legacyId = `heading-${index + 1}`;
        if (!heading.id) {
          let id = legacyId;
          let suffix = 2;
          while (document.getElementById(id)) id = `${legacyId}-${suffix++}`;
          heading.id = id;
        } else if (heading.id !== legacyId && !document.getElementById(legacyId)) {
          // Retain the previous template's public fragment links as well as authored IDs.
          const alias = document.createElement('span');
          alias.id = legacyId;
          alias.className = 'article-heading-anchor';
          alias.setAttribute('aria-hidden', 'true');
          heading.before(alias);
        }
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.className = 'toc-link';
        link.textContent = heading.textContent.trim();
        links.append(link);
      });
      navigation.replaceChildren(links);
      contents.hidden = headings.length === 0;

      const desktop = window.matchMedia('(min-width: 1024px)');
      const updateDisclosure = () => { contents.open = desktop.matches; };
      updateDisclosure();
      desktop.addEventListener('change', updateDisclosure);
      cleanups.set(article, () => desktop.removeEventListener('change', updateDisclosure));

      body.querySelectorAll('table').forEach(table => {
        table.tabIndex = 0;
        table.setAttribute('role', 'region');
        table.setAttribute('aria-label', table.caption?.textContent.trim() || 'Tabel i artiklen');
      });

      const blockId = body.dataset.enhanceProductLinks;
      if (blockId) enhanceProductLinks(blockId, body);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeArticles(), { once: true });
  } else {
    initializeArticles();
  }
  document.addEventListener('shopify:section:load', event => initializeArticles(event.target));
  document.addEventListener('shopify:section:unload', event => {
    cleanups.forEach((cleanup, article) => {
      if (event.target.contains(article)) {
        cleanup();
        cleanups.delete(article);
      }
    });
  });
})();

function enhanceProductLinks(blockId, root = document) {
  const selector = root.matches?.('.article__content') ? 'a[href]' : '.article__content a[href]';
  root.querySelectorAll(selector).forEach((link, index) => {
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin || !url.pathname.startsWith('/products/') || link.closest('quick-view-product')) return;
    const enhancedLink = document.createElement('quick-view-product');
    link.setAttribute('data-js-product-add-to-cart', '');
    link.dataset.id = `product-${blockId}-${index}`;
    link.replaceWith(enhancedLink);
    enhancedLink.append(link);
  });
}
